

document.addEventListener('DOMContentLoaded', function () {
    const button = document.getElementById('cart-btn');
    if (button) {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        if (window.Rebuy && window.Rebuy.SmartCart) {
          window.Rebuy.SmartCart.show();
        }
      });
    }
  });

// sets start
if ($(window).width() < 768) {
    $('.sets__items').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots:false,
        autoplay:true,
        autoplaySpeed: 3000, 
    });
}


// sets end



// btn hover start



$(function () {
    // Position the ripple animation span (last direct-child <span>) at the
    // cursor. Using `> span:last-child` avoids repositioning content spans
    // like `.cart-btn__label` or `.cart-btn__price-wrap`.
    $('.btn')
        .on('mouseenter', function (e) {
            var parentOffset = $(this).offset(),
                relX = e.pageX - parentOffset.left,
                relY = e.pageY - parentOffset.top;
            $(this).children('span').last().css({ top: relY, left: relX })
        })
        .on('mouseout', function (e) {
            var parentOffset = $(this).offset(),
                relX = e.pageX - parentOffset.left,
                relY = e.pageY - parentOffset.top;
            $(this).children('span').last().css({ top: relY, left: relX })
        });
    $('[href="#"]').click(function () { return false });
});



// btn hover end



//   marquee start
function initIngredS2() {
    var $slider = $('.ingred-s2__slider');
    if (!$slider.length || $slider.hasClass('slick-initialized')) return;
    $slider.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: true,
      responsive: [{
        breakpoint: 1024,
        settings: { slidesToShow: 1 }
      }]
    });
    // Wire desktop inline nav + mobile bottom nav to the same slider
    $('.ingred-s2__nav--prev, .ingred-s2__nav--prev-m').on('click', function () {
      $slider.slick('slickPrev');
    });
    $('.ingred-s2__nav--next, .ingred-s2__nav--next-m').on('click', function () {
      $slider.slick('slickNext');
    });
  }
  $(document).ready(initIngredS2);

$(".marquee__items").slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: "linear",
    variableWidth: true,
    arrows: false,
    pauseOnHover: false,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
            },
        },
    ],
});



//   marquee end


// KLAVIYO FORM API START HERE
if($('.signup-form').length > 0){
    $('body').on('click','.btn_newsletter',function(e){
      e.preventDefault();
      var api = $(this).data('public-api'),
      form = $(this).parents('.signup-form'),
      listID = form.find('input[name="list-id"]').val();
      // console.log('api',api);
      // console.log('email:',form.find('input[type=email]').val());
      var formData = '{"data": {"type": "subscription","attributes": {"profile": {"data": {"type": "profile","attributes": {"email": "'+form.find('input[type=email]').val()+'"}}},"custom_source": "Website signup form"},"relationships": {"list": {"data": {"type": "list","id": "'+listID+'"}}}}}';
      const settings = {
        async: true,
        crossDomain: true,
        url: 'https://a.klaviyo.com/client/subscriptions?company_id='+api,
        method: 'POST',
        headers: {
          accept: 'application/vnd.api+json',
          revision: '2025-01-15',
          'content-type': 'application/vnd.api+json'
        },
        data: formData
      };
      
      $.ajax(settings).done(res => {
        // console.log(res);
        form.find('.footer__input-btn').hide();
        form.find('.form-msg-success').show();
      });
      
    });
  }
// KLAVIYO FORM API END HERE


// video modal js start here 

// $(".featured-product__accordion-video-icon").on("click", function () {
//     var video_url = $(this).attr("data-video-rul");
//     var poster_url = $(this).attr("data-poster");
//     $(".featured-product__video-modal").show();
//     $("body").addClass("open-video");

//     $(".featured-product__video-modal-src").attr("src", video_url);
//     $(".featured-product__video-modal video").attr("poster", poster_url);
// });


// $(".featured-product__accordion-video-icon").on("click", function () {
//     // Get the video URL and poster from data attributes
//     var video_url = $(this).attr("data-video-rul");
//     var poster_url = $(this).attr("data-poster");

//     // Show the video modal
//     $(".featured-product__video-modal").show();
//     $("body").addClass("open-video");

//     // Set the video source and poster dynamically
//     $(".featured-product__video-modal-src").attr("src", video_url);
//     $(".featured-product__video-modal video").attr("poster", poster_url);

//     // Ensure the video is loaded before playing
//     var videoElement = $(".featured-product__video-modal video")[0];
    
//     // Wait for the video to load and then play
//     videoElement.load();  // Load the new video source
//     videoElement.play();  // Play the video
// });



var videoElement = $(".featured-product__video-modal video")[0];
$(".featured-product__accordion-video-icon").on("click", function () {
    var video_url = $(this).attr("data-video-rul");
    var poster_url = $(this).attr("data-poster");
    $(".featured-product__video-modal").show();
    $("body").addClass("open-video");
    $(".featured-product__video-modal-src").attr("src", video_url);
    $(".featured-product__video-modal video").attr("poster", poster_url);
    videoElement = $(".featured-product__video-modal video")[0];
    videoElement.load();
    videoElement.play();
    videoElement.loop = true;
});


// $(".announcement__text a").on("click", function (e) {
//     e.preventDefault(); 
//     var video_url = $(this).attr("href");
//     $(".featured-product__video-modal_announcement").show();
//     $("body").addClass("open-video");
//     $(".featured-product__video-modal_announcement .featured-product__video-modal-src").attr("src", video_url);
//     videoElement = $(".featured-product__video-modal_announcement video")[0];
//     videoElement.load();
//     videoElement.play();
//     videoElement.loop = true;
// });



// $(".featured-product__accordion-video-play").on("click", function () {
//     // Get the video element
//     var videoElement = $(".featured-product__video-modal video")[0];

//     if (videoElement) {
//         videoElement.load();
//         videoElement.muted = true;
//         videoElement.play().then(function() {
           
//             $(".featured-product__accordion-video-play").hide(1000);
//         }).catch(function(error) {
//             console.error("Error playing the video: ", error);
//         });
//     } else {
//         console.error("Video element is not found!");
//     }
// });








$(".featured-product__video-close").on("click", function () {
    $("body").removeClass("open-video");
    $(".featured-product__video-modal").hide();
    $(".featured-product__accordion-video-play").show();
    if (videoElement) {
        videoElement.pause();  // Pause the video
        videoElement.currentTime = 0;  
    }
});

$(".overlay").on("click", function () {
    $("body").removeClass("open-video");
    $(".featured-product__video-modal").hide();
    $(".featured-product__accordion-video-play").show();
    if (videoElement) {
        videoElement.pause();  
        videoElement.currentTime = 0;  
    }
});

// video modal js end here

// makes__scroll-video: GSAP scroll-scrub for .makes__scroll-video (runs after GSAP is available)
(function () {
  function runScrollVideoInit() {
    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return false;
    gsap.registerPlugin(ScrollTrigger);

  function addScrollScrub(video) {
    if (!video) return;
    function setup() {
      if (!video.duration || isNaN(video.duration) || video.readyState < 1) {
        video.addEventListener("loadedmetadata", setup, { once: true });
        return;
      }

      const proxy = { t: 0 };

      // Remove any previous ScrollTriggers for this video
      ScrollTrigger.getAll().forEach(st => {
        if (st.vars.trigger === (video.closest('.makes__main-img') || video)) {
          st.kill();
        }
      });

      gsap.to(proxy, {
        t: video.duration,
        ease: "none",
        scrollTrigger: {
          trigger: video.closest('.makes__main-img') || video,
          start: "top center",
          end: "top top",
          scrub: 0.35,
          onUpdate: function(self) {
            // Lerp for smoothness within bounds
            if (video.readyState > 0) {
              video.currentTime = Math.min(video.duration, Math.max(0, proxy.t));
            }
          },
          onLeave: function(self) {
            // When quickly scrolling past end, force currentTime to end
            if (video.readyState > 0) {
              video.currentTime = video.duration;
            }
          },
          onLeaveBack: function(self) {
            // When quickly scrolling before start, force currentTime to 0
            if (video.readyState > 0) {
              video.currentTime = 0;
            }
          }
        }
      });
    }
    setup();
  }

  function runForAllVideos() {
    document.querySelectorAll('.makes__scroll-video').forEach(addScrollScrub);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runForAllVideos);
  } else {
    runForAllVideos();
  }
  return true;
  }

  function tryRun() {
    if (runScrollVideoInit()) return;
    var attempts = 0;
    var maxAttempts = 100;
    var interval = setInterval(function () {
      attempts++;
      if (runScrollVideoInit() || attempts >= maxAttempts) clearInterval(interval);
    }, 50);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", tryRun);
  } else {
    tryRun();
  }
})();


// mouthcare start



if ($(Window).width() < 768) {
    $('.mouthcare__items').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
        ]
    });
}


// mouthcare end



// second-marquee start


$(".second-marquee__items").slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: "linear",
    variableWidth: true,
    arrows: false,
    pauseOnHover: false,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
            },
        },
    ],
});


// second-marquee end



// slider start

// $('.slider__items').slick({
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows: false,
//     fade: true,
//     autoplay: true,
//     autoplaySpeed: 3000,
//     responsive: [
//         {
//             breakpoint: 768,
//             settings: {
//                 slidesToShow: 1,
//                 slidesToScroll: 1,
//             }
//         },
//     ]
// });



$('.slider__previous').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.slider__after').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});


// slider end





// reviews start


$('.reviews__items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
    ]
});



// reviews end




// slide-with-img start



$('.slide-with-img__text-items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    vertical: true,
    verticalSwiping: true,
    asNavFor: '.slide-with-img__img-items',
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
    ]
});

$('.slide-with-img__img-items').slick({
    slidesToShow: 4, // Default for Desktop
    slidesToScroll: 1,
    asNavFor: '.slide-with-img__text-items',
    centerMode: false,
    focusOnSelect: true,
    arrows: false,
    responsive: [
        {
            breakpoint: 768, // Mobile View
            settings: {
                dots: true,
                slidesToShow: 1 // Show only 1 image in mobile
            }
        }
    ]
});



// slide-with-img end



// gallery  start


$(".gallery__items").slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: "linear",
    variableWidth: true,
    arrows: false,
    pauseOnHover: false,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
            },
        },
    ],
});



// gallery  end


// menu start


$(".header__mobi-menu , .header__desk-shop a").on('click', function (e) {
    e.preventDefault();
    $("body").addClass('active-menu')
})

$(".menu__close , .overlay").on('click', function () {
    $("body").removeClass('active-menu');
})



// menu end


// cart-drawer start


$('.cart-drawer__upsell-items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
    ]
});




// $(".header__cart").on('click', function () {
//     $("body").addClass('active-cart')
// })

// $(".cart-drawer__close , .overlay").on('click', function () {
//     $("body").removeClass('active-cart');
// })



$(document).ready(function () {
    function startCountdown() {
        const timerElement = $(".countdown__timer");
        if (!timerElement.length) {
            return;
        }

        const endTimeString = timerElement.data("end-time");
        if (!endTimeString) {
            return;
        }

        const endDate = new Date(endTimeString.replace(" ", "T")).getTime();
        // const messageElement = $(".countdown-message");
        let removedFirstChild = false;
        if (isNaN(endDate)) {
            // console.error("Invalid end date provided in the theme editor.");
            timerElement.text("Invalid countdown end date.");
            return;
        }
        function updateCountdown() {
            const now = new Date().getTime();
            const timeLeft = endDate - now;
            if (timeLeft <= 0) {
                clearInterval(countdownInterval);
                // timerElement.hide();
                // messageElement.show();
                return;
            }
            const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
            const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
            // Use padStart for double digits in all time components
            timerElement.find(".count__day").text(days.toString().padStart(1, "0") + "D");
            // timerElement.find(".hours").text(hours.toString().padStart(1, "0"));
            timerElement.find(".count__minute").text(minutes.toString().padStart(1, "0") + "M");
            timerElement.find(".count__second").text(seconds.toString().padStart(1, "0") + "S");
        }
        const countdownInterval = setInterval(updateCountdown, 1000);
        updateCountdown(); // Initial call
    }
    startCountdown();
});


// timer js end here 



(function () {
    var sliderCounter = 0;

    function ensureWrapper(target) {
        if (!target) return $();
        if (target instanceof jQuery) return target;
        if (target.nodeType) return $(target);
        if (typeof target === 'string') {
            var trimmed = target.trim();
            if (!trimmed.length) return $();
            if (trimmed[0] === '.' || trimmed[0] === '#') {
                return $(trimmed);
            }
            return $('.product-slider-wrapper.' + trimmed);
        }
        return $();
    }

    function prepareWrapper($wrapper) {
        if (!$wrapper || !$wrapper.length) return null;
        var key = $wrapper.attr('data-slider-key');
        if (!key) {
            sliderCounter += 1;
            key = 'product-slider-' + sliderCounter;
            $wrapper.attr('data-slider-key', key);
        }

        var $big = $wrapper.find('.product__images');
        var $thumbs = $wrapper.find('.featured-product__small-imgs');

        if ($big.length) {
            $big.attr('data-slider-owner', key);
        }
        if ($thumbs.length) {
            $thumbs.attr('data-slider-owner', key + '-thumbs');
        }

        return {
            key: key,
            big: $big,
            thumbs: $thumbs,
            bigSelector: '.product__images[data-slider-owner="' + key + '"]',
            thumbSelector: '.featured-product__small-imgs[data-slider-owner="' + key + '-thumbs"]'
        };
    }

    function destroySlider($el) {
        if ($el && $el.length && $el.hasClass('slick-initialized')) {
            $el.slick('unslick');
        }
    }

    function mountSlider($wrapper, options) {
        var settings = $.extend({ force: false }, options);
        if (!$wrapper || !$wrapper.length) return;

        if (!settings.force && !$wrapper.is(':visible')) {
            $wrapper.attr('data-slider-pending', 'true');
            return;
        }

        $wrapper.removeAttr('data-slider-pending');
        var parts = prepareWrapper($wrapper);
        if (!parts || !parts.big.length) return;

        destroySlider(parts.big);
        destroySlider(parts.thumbs);

        var bigOptions = {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },
            ]
        };

        if (parts.thumbs.length) {
            bigOptions.asNavFor = parts.thumbSelector;
        }

        parts.big.slick(bigOptions);

        if (parts.thumbs.length) {
            parts.thumbs.slick({
                slidesToShow: 5,
                slidesToScroll: 1,
                vertical: true,
                asNavFor: parts.bigSelector,
                infinite:false,
                centerMode: false,
                focusOnSelect: true,
                arrows: false,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            vertical: false,
                            slidesToShow: 5,
                            slidesToScroll: 1
                        }
                    },
                ]
            });
        }
    }

    function initAllSliders() {
        $('.product-slider-wrapper').each(function () {
            mountSlider($(this));
        });
    }

    function refreshSlider(target) {
        var $wrapper = ensureWrapper(target);
        if (!$wrapper || !$wrapper.length) return;
        $wrapper.each(function () {
            mountSlider($(this), { force: true });
        });
    }

    window.MightyProductSliders = window.MightyProductSliders || {};
    window.MightyProductSliders.initAll = initAllSliders;
    window.MightyProductSliders.refresh = refreshSlider;

    $(function () {
        initAllSliders();
    });
})();

function equalheight() {
    $('.custom-review__items').each(function (index) {
        var maxHeight = 0;
        $(this).find('.slick-slide').height('auto');
        $(this).find('.slick-slide').each(function (index) {
            if ($(this).height() > maxHeight)
                maxHeight = $(this).height();
        });
        $(this).find('.slick-slide').height(maxHeight);
    });
}

$('.custom-review__items').on('init', function(event, slick){
  equalheight();
});

$('.custom-review__items').slick({
    vertical: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    adaptiveHeight: false,
    pauseOnHover: false,
    // draggable: false,
    pauseOnFocus: false,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
    ]
});





// inside-mighty start

$(".featured-product__accordion-title").click(function () {
    if ($(this).hasClass('active')) {
        $(this).removeClass("active");
        $(this).next(".featured-product__accordion-content").slideUp();
    } else {
        $(".featured-product__accordion-content").slideUp();
        $(".featured-product__accordion-title").removeClass("active");
        $(this).addClass("active");
        $(this).next(".featured-product__accordion-content").slideDown();
    }
    var videoElement = $(this).next(".featured-product__accordion-content").find("video")[0];
    videoElement.load();
    videoElement.play();
    videoElement.loop = true;
})
$.fn.isInViewport = function () {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};
$(window).on('resize scroll', function () {
    if ($('.smile-logo').length > 0) {
        $('.smile-logo').each(function () {
            if ($(this).isInViewport()) {
                const logoPlayer = $(this).get(0);
                if (logoPlayer && typeof logoPlayer.setSpeed === 'function') {
                    setTimeout(() => {
                        logoPlayer.setSpeed(1);
                        logoPlayer.setDirection(1);
                        logoPlayer.play();
                    }, 500);
                }
            }
        })
    }
});

$('.inside-mighty__items-1').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    // speed: 1000,
    asNavFor: '.inside-mighty__items-2, .inside-mighty__items-3',
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});

$('.inside-mighty__items-2').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    // speed: 1000,
    asNavFor: '.inside-mighty__items-1, .inside-mighty__items-3',
    centerMode: false,
    focusOnSelect: true,
    arrows: false,
});

$('.inside-mighty__items-3').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    // speed: 1000,
    asNavFor: '.inside-mighty__items-1, .inside-mighty__items-2',
    centerMode: false,
    focusOnSelect: true,
    arrows: false,
});





$('.inside-mighty__previous').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.inside-mighty__next').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});



// inside-mighty end


// Smooth scroll to anchor, even across pages

(function() {
    // Function to perform smooth scroll to anchor if selector found
    function scrollToAnchor(anchor) {
        var target = document.getElementById(anchor) || document.querySelector('[name="' + anchor + '"]');
        if (target) {
            var yOffset = -80; // Adjust this (-80) if you have a fixed header, else set to 0
            var y = target.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    }

    // Click handler for anchor links
    $(document).on('click', 'a[href^="#"], a[href*="#"]', function(e) {
        var href = $(this).attr('href');
        if (!href) return;
        var anchorIndex = href.indexOf('#');
        if (anchorIndex === -1) return;

        var anchor = href.substring(anchorIndex + 1);
        if (!anchor) return;

        var linkPath = this.pathname.replace(/^\//, '');
        var currentPath = window.location.pathname.replace(/^\//, '');
        var linkHost = this.hostname;
        var currentHost = window.location.hostname;

        if (linkHost === currentHost && linkPath === currentPath) {
            // Same page - smooth scroll
            var $target = $('#' + anchor);
            if ($target.length) {
                e.preventDefault();
                scrollToAnchor(anchor);
                // Change URL hash without jump
                history.replaceState(null, null, '#' + anchor);
            }
        } else if (linkHost === currentHost) {
            // Same site, different page — set localStorage and redirect
            localStorage.setItem('scrollToAnchor', anchor);
            // strip only the anchor from the href
            var fullPath = href.substring(0, anchorIndex);
            window.location.href = fullPath + '#' + anchor;
            // let the scroll run on next page load
        }
        // else: leave external links alone
    });

    // On page load: if there's a hash in the URL or in localStorage, scroll smoothly
    $(function() {
        var anchor = null;

        // First, check localStorage
        if (localStorage.getItem('scrollToAnchor')) {
            anchor = localStorage.getItem('scrollToAnchor');
            // Remove after use to prevent future false positives
            localStorage.removeItem('scrollToAnchor');
        } else if (window.location.hash && window.location.hash.length > 1) {
            anchor = decodeURIComponent(window.location.hash.substring(1));
        }

        if (anchor) {
            // Some Shopify pages may load late, so delay scroll
            setTimeout(function() {
                scrollToAnchor(anchor);
            }, 300);
        }
    });
})();



// faq start


$(".accordion__title").click(function () {
    if ($(this).hasClass('active')) {
        $(this).removeClass("active");
        $(this).next(".accordion__content").slideUp();
    } else {
        $(".accordion__content").slideUp();
        $(".accordion__title").removeClass("active");
        $(this).addClass("active");
        $(this).next(".accordion__content").slideDown();
    }
    
})


// faq end

// Auto (re)initialize .slick on .method__items-wrap for responsive (re)activation
function initMethodItemsSlider() {
    if ($(window).width() < 768) {
        if (!$('.method__items-wrap').hasClass('slick-initialized')) {
            $('.method__items-wrap').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                mobileFirst: true,
                prevArrow: $('.method__arrow__left-arrow'),
                nextArrow: $('.method__arrow__right-arrow'),
                responsive: [
                    {
                        breakpoint: 768,
                        settings: "unslick"
                    }
                ]
            });
        }
    } else {
        if ($('.method__items-wrap').hasClass('slick-initialized')) {
            $('.method__items-wrap').slick('unslick');
        }
    }
}

// On page load
$(document).ready(function() {
    if ($('.method__items-wrap').length > 0) {
        initMethodItemsSlider();
        // Re-initiate on window resize
        $(window).on('resize', function() {
            initMethodItemsSlider();
        });
    }
});


// makes mobile slider start


if ($(Window).width() < 1024) {
    $('.makes__items').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
    });
}

$('.makes__left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.makes__right-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});

// makes mobile slider end



// Start Slick Slider For Hero Ingred
if ($(Window).width() < 768) {
    $('.hero-ingred__items').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false
    });
}

$('.hero-ingred__left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.hero-ingred__right-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});
// End Slick Slider For Hero Ingred


// Start Slick Slider For Step
if ($(Window).width() < 768) {
    $('.step__items').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
    });
}

$('.step__left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.step__right-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});
// End Slick Slider For Step



// customer-reviews slider start



$('.customer-reviews__items').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
            }
        },
    ]
});

$('.customer-reviews__left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.customer-reviews__right-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});



// customer-reviews slider end